export default __webpack_public_path__ + "static/media/show-3.cb58eb04.svg";